import BaseError from '@whr/core_utils/baseError.js'

export class LocalStorageKeyNotSetError extends BaseError<'LOCAL_STORAGE|NOT_SET'> {
  constructor (message: string, originalError?: any) {
    super('LOCAL_STORAGE|NOT_SET', message, originalError, 500)
  }
}
